/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCompanyDto
 */
export interface UpdateCompanyDto {
    /**
     * Company name
     * @type {string}
     * @memberof UpdateCompanyDto
     */
    name?: string;
    /**
     * URL or identifier for company logo
     * @type {string}
     * @memberof UpdateCompanyDto
     */
    logo?: string;
}

/**
 * Check if a given object implements the UpdateCompanyDto interface.
 */
export function instanceOfUpdateCompanyDto(value: object): value is UpdateCompanyDto {
    return true;
}

export function UpdateCompanyDtoFromJSON(json: any): UpdateCompanyDto {
    return UpdateCompanyDtoFromJSONTyped(json, false);
}

export function UpdateCompanyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCompanyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'logo': json['logo'] == null ? undefined : json['logo'],
    };
}

export function UpdateCompanyDtoToJSON(json: any): UpdateCompanyDto {
    return UpdateCompanyDtoToJSONTyped(json, false);
}

export function UpdateCompanyDtoToJSONTyped(value?: UpdateCompanyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'logo': value['logo'],
    };
}

